var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEyeopen1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 11,
    viewBox: "0 0 22 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M1.08984 6.08994C6.56284 -0.957063 15.4358 -0.957063 20.9088 6.08994",
    stroke: "#9392A2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M14.431 2.31802C16.1884 4.07538 16.1884 6.92462 14.431 8.68198C12.6736 10.4393 9.8244 10.4393 8.06704 8.68198C6.30968 6.92462 6.30968 4.07538 8.06704 2.31802C9.8244 0.56066 12.6736 0.56066 14.431 2.31802Z",
    stroke: "#9392A2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeopen1);
export default __webpack_public_path__ + "static/media/eyeopen1.a04cccf389981c57027e1d551da368dc.svg";
export { ForwardRef as ReactComponent };